import { render, staticRenderFns } from "./InOutInvRecordDetail.vue?vue&type=template&id=4b22933c&scoped=true&"
import script from "./InOutInvRecordDetail.vue?vue&type=script&lang=js&"
export * from "./InOutInvRecordDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b22933c",
  null
  
)

export default component.exports